import * as api from "../constants/api";
import axios from "../services/axios";
import * as handle from "../utils/actionUtils";

import { addFlashMessage } from "./FlashMessagesAction";

export const GET_ILEGGELSE_MAKULERINGER_SUCCESS =
  "GET_ILEGGELSE_MAKULERINGER_SUCCESS";

export function getIleggelseMakuleringer(ileggelseId) {
  return async (dispatch) => {
    return axios
      .get(api.GET_ILEGGELSE_MAKULERINGER_URL(ileggelseId))
      .then(handle.success(dispatch, GET_ILEGGELSE_MAKULERINGER_SUCCESS))
      .catch((error) => {
        dispatch(
          addFlashMessage({
            type: "error",
            message: error,
          }),
        );
        return Promise.reject(true);
      });
  };
}

const POST_ILEGGELSER_MAKULERING_FAILURE = "POST_ILEGGELSER_MAKULERING_FAILURE";

export function postIleggelserMakulering(ileggelseId, kommentar) {
  return (dispatch, getState) => {
    return axios
      .post(api.POST_ILEGGELSER_MAKULERING_URL(ileggelseId, kommentar), {
        kommentar,
        // Use current UTC timestamp in ISO format (previously moment.utc())
        makulertDato: new Date().toISOString(),
      })
      .then(() => {
        return Promise.resolve(true);
      })
      .catch((response) => {
        dispatch(
          addFlashMessage({
            type: "error",
            message: response,
          }),
        );
        handle.error(dispatch, POST_ILEGGELSER_MAKULERING_FAILURE);
        return Promise.reject(true);
      });
  };
}

export function deleteIleggelseMakulering(ileggelseMakuleringId) {
  return (dispatch, getState) => {
    return axios
      .delete(api.DELETE_ILEGGELSE_MAKULERINGER_URL(ileggelseMakuleringId))
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  };
}
